import React, { useState, useEffect, Fragment } from "react";
import PrimaryButton from "components/Buttons/PrimaryButton";
import { apiPut, apiPost, apiGet } from "helpers/Request";
import { useAuth } from "hooks/Auth";
import { toast } from "react-hot-toast";
import { transform as channelTransformer } from "schemas/Channel";
import {
    transform as entryTransformer,
    EntryObjectSchema,
} from "schemas/Entry";
import { CubeIcon } from "@heroicons/react/outline";
import EntryEditor from "Screens/EntryScreen/EntryEditor";

export default function SeoPanel(props) {
    const auth = useAuth();

    const [channel, setChannel] = useState(null);
    const [entry, setEntry] = useState(null);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const onSubmit = (values, originalValues) => {
        setSaving(true);
        const data = {
            channel_id: channel.id,
            title: entry?.title || null,
            slug: entry?.slug || null,
            entryMeta: values,
            hidden: true,
        };

        const apiAction = entry.uuid ? apiPut : apiPost;
        apiAction(`/v4/entry/${entry.uuid || ""}`, auth.publication, data)
            .then((resp) => {
                toast.success("Saved");
                setEntry(entryTransformer(resp));
            })
            .catch((e) => {
                toast.error("Unable to save " + e.message);
            })
            .finally(() => {
                setSaving(false);
            });
    };

    useEffect(() => {
        apiGet("/v4/channel", auth.publication, { include: ["settings"] })
            .then((resp) => {
                const channels = channelTransformer(resp);
                const seoChannel = channels.find(
                    (c) => c.slug === "seo-settings"
                );
                if (!seoChannel) {
                    throw Error("Error loading SEO settings");
                }
                setChannel(seoChannel);
                setLoading(false);

                return seoChannel;
            })
            .then((seoChannel) => {
                return apiGet("/v4/entry", auth.publication, {
                    channel: seoChannel.id,
                    per_page: 1,
                    show_hidden: true,
                });
            })
            .then((resp) => {
                const entry = entryTransformer(resp);
                if (entry.length) {
                    setEntry(entry.pop());
                } else {
                    setEntry(EntryObjectSchema);
                }
            })
            .catch((e) => {
                toast.error("Error loading SEO settings");
            });

        return () => {
            setChannel(null);
            setLoading(true);
        };
    }, [auth.publication]);

    if (loading) {
        return (
            <div className="flex h-full flex-grow items-center justify-center">
                <CubeIcon className="inline-block h-10 w-10 animate-rotate-pulse text-gray-300" />
            </div>
        );
    }

    return (
        <EntryEditor
            onSubmit={onSubmit}
            channel={channel}
            entry={entry || EntryObjectSchema}
            className="flex h-full w-full flex-col"
            variant="white"
        >
            {(fields) => (
                <Fragment>
                    <div className="flex-grow overflow-auto p-4">
                        <div className="w-full space-y-8">
                            <div className="prose text-sm">
                                Override default SEO properties and insert meta
                                tags for the header of your CEO Front End site.
                                Changes may take up to 10 minutes to take
                                effect.
                            </div>
                            {fields}
                        </div>
                    </div>
                    <div className="w-full bg-gray-50 p-2 text-right">
                        <PrimaryButton
                            label="Save Changes"
                            type="submit"
                            blocking={saving}
                        />
                    </div>
                </Fragment>
            )}
        </EntryEditor>
    );
}
